<template>
  <div class="content">
    <el-row style="height:28px">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <!-- <el-breadcrumb-item>系统配置</el-breadcrumb-item> -->
            <el-breadcrumb-item>台账管理</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container style="height:calc(100% - 30px);width:100%;position: relative;">
      <el-main style="height: 100%;padding:0px !important;  position: relative;width: 100%;">
        <el-card style="height:100% !important;" class="aside">
          <!--  -->
          <div class="build-table">
            <div
              style="display:flex;border-top:10px solid #f5f5f5;width:100%;height:80px;align-items:center;justify-content: flex-end;padding:0px 10px"
            >
              <!-- <el-input
                v-model="search.name"
                placeholder="请输入试卷名称"
                clearable
                @input="watchInput"
                style="width:220px;padding:10px"
              >
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>-->
              <el-button type="primary" icon="el-icon-plus" @click="addFun">添加</el-button>
            </div>
            <!--  -->
            <div style="width:100%;height:calc(100% - 140px)">
              <el-table
                stripe
                :data="listData"
                height="100%"
                style="width: 100%;"
                :default-sort="{prop: 'createDate', order: 'descending'}"
                :header-cell-style="{background:'#F5F7F9',color:'#909399',}"
                :cell-style="rowClass"
                @row-click="openDetails"
              >
                <template slot="empty">
                  <p>{{dataText}}</p>
                </template>
                <el-table-column label="序号" width="100">
                  <template slot-scope="scope">
                    <a>{{ scope.row.index}}</a>
                  </template>
                </el-table-column>
               
                <el-table-column label="标题">
                  <template slot-scope="scope">
                    <a>{{ scope.row.title}}</a>
                  </template>
                </el-table-column>
                <!-- <el-table-column label="内容" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <span>{{ scope.row.content }}</span>
                  </template>
                </el-table-column> -->
                <el-table-column label="日期">
                  <template slot-scope="scope">
                    <span>{{ scope.row.createDate }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="200">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="primary"
                      icon="el-icon-edit"
                      @click.native.stop="handleEdit(scope.$index, scope.row)"
                    ></el-button>
                    <el-button
                      size="mini"
                      type="danger"
                      icon="el-icon-delete"
                      @click.native.stop="handleDel(scope.$index, scope.row)"
                    ></el-button>
                  </template>
                </el-table-column>
              </el-table>
              <!-- 添加弹框 -->
              <!-- 新增窗口 -->
              <!-- <el-dialog
                :title="dialogTitle"
                :visible.sync="addFormVisible"
                center
                width="800px"
                :append-to-body="true"
                :lock-scroll="false"
                class="add-form"
              >
                <el-form
                  :model="addForm"
                  label-width="200px"
                  ref="addForm"
                  label-position="right"
                  :rules="rules"
                >
                  <el-form-item label="图片">
                    <el-upload
                      :action="uploadphotoUrl"
                      list-type="picture-card"
                      :on-preview="handlePictureCardPreview"
                      :on-remove="handleRemove"
                      :headers="uploadHead"
                      :data="uploadphotoData"
                      :on-success="handleIconSuccess"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                      <img width="100%" :src="dialogImageUrl" alt />
                    </el-dialog>
                  </el-form-item>
                  <el-form-item label="标题：" prop="title">
                    <el-input v-model="addForm.title" autocomplete="off" style="width:217px"></el-input>
                  </el-form-item>
                  <el-form-item label="内容：" prop="content">
                    <el-input
                      type="textarea"
                      :rows="4"
                      v-model="addForm.content"
                      autocomplete="off"
                      style="width:217px;height:200px"
                    ></el-input>
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="addFormVisible = false">取 消</el-button>
                  <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
                </div>
              </el-dialog> -->
            </div>
            <!-- 分页展示 -->
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[3, 5, 10,20]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
import base from '../../../untils/base'
export default {
  data() {
    return {
      search: {
        //查询
        name: '',
        groupId: '',
      },
      listData: [], //表格数据
      addForm: {
        // groupType:'1',//组织类型，1项目，2施工企业，3建设企业
        id: '',
        title: '', //标题
        content: '', //内容
        thumbnailUrl: '', //缩略图片
        photoUrl: '', //图片
        type: '2', //1 2法律法规
      },
      dialogTitle: '',
      addFormVisible: false,
      groupId: '',
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      storeOpt: [], //题库

      dataText: '数据加载中...',
      rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        content: [{ required: true, message: '请输入内容', trigger: 'blur' }],
      },
      groupType: '',
      groupId: '',
      createBy: util.session.get('user').id,
      uploadphotoUrl: base.url + '/upload/uploadPhotosAndThumbnail',
      uploadHead: {
        accessToken: util.session.get('token'),
      },
      uploadphotoData: {
        type: '221',
      },
      type: 2,
      dialogImageUrl: '',
      dialogVisible: false,
      photoList: [], //多张普通图片
      photoThum: [], //多张缩略图
    }
  },

  mounted() {
    this.groupId = util.session.get('groupId')
    // console.log(this.addForm.scope)
    if ('' == this.groupId) {
      this.$store.commit('setGroupId')
      this.$store.commit('getRoleId')
      this.groupId = this.$store.state.groupId
    }
    this.search.groupId = this.groupId
    if (util.session.get('roleId') == '3') {
      this.groupType = '3'
    } else if (this.$store.state.roleId == '4') {
      this.groupType = '1'
    } else if (this.$store.state.roleId == '5') {
      this.groupType = '2'
    }
    // console.log(this.groupId)
    this.getData()
  },
  methods: {
    //查询
    doFilter() {
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    rowClass() {
      //表头居中显示
      return 'text-align:center'
    },
    // 获取数据
    getData() {
      var that = this
      this.search.entId = this.groupId
      this.search.joinType = this.groupType
      this.search.pageSize = this.pageSize
      this.search.pageNum = this.currentPage
      this.search.type = this.type
      myHttp.selectProDocumentationPage(this.search).then(
        function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.pageInfo.list || []
            for (var i = 0; i < list.length; i++) {
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
              list[i].thumbnailUrl_view = list[i].thumbnailUrl?base.httpCtx + list[i].thumbnailUrl:''
            }
            that.totalItems = resp.data.data.total || 0
            that.listData = list
            if (that.listData.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '服务器出错'
          }
        },
        function () {}
      )
    },
    //修改
    handleEdit(index, row) {   
      // if(this.groupType=='3'){
      //   this.$router.push({path:'/editorTextBuild/'+row.id+'/'+this.type})
      // }else{
        this.$router.push({path:'/owneredit/'+row.id+'/'+this.type})
      // }
      // this.$router.push({path:'/editorText/'+row.id+'/'+this.type})
    },
    //保存
    sumbitAddRow(formName) {
      var that = this
      this.addForm.entId = this.groupId
      // this.addForm.groupType = this.groupType
      this.addForm.createBy = this.createBy
      this.addForm.joinType = this.groupType
      // console.log(this.addForm)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!that.addForm.id) {
            myHttp.createInfoNo(that.addForm).then(function (resp) {
              if (resp.data.code == '200') {
                that.addFormVisible = false
                that.$message.success('创建成功')
                that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
            })
          } else {
            this.addForm.updateBy = this.createBy
            myHttp.updateInfoNo(that.addForm).then(function (resp) {
              if (resp.data.code == '200') {
                that.addFormVisible = false
                that.$message.success('修改成功')
                that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
            })
          }
        }
      })
    },
    // handleNodeClick(data) {
    //   console.log(data)
    // },
    //添加
    addFun() {
      // this.dialogTitle = '添加'
      // this.checkData = []
      // ;(this.addForm = {
      //   id: '',
      //   title: '',
      //   content: '',
      //   thumbnailUrl: '', //缩略图片
      //   photoUrl: '', //图片
      //   type: '1', //1 2法律法规
      // }),
      //   (this.addFormVisible = true)      
      // if(this.groupType=='3'){
      //   this.$router.push({path:'/textRichBuild/'+this.type})
      // }else{
        this.$router.push({path:'/ownerAdd/'+this.type})
      // }
      
    },
    //删除
    handleDel(index, row) {
      var that = this
      this.$confirm('此操作将永久删除该, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          myHttp
            .deleteProDocumentationLogic({
              id: row.id,
              updateBy: this.createBy,
            })
            .then(function (resp) {
              if (resp.data.code == '200') {
                that.$message.success('删除成功')
                that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
            })
        })
        .catch((err) => {})
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
      if ((file.response.code = 200)) {
        var arr1 = file.response.data.savePhotoUrls.split(',')
        var arr2 = file.response.data.saveThumbnailUrls.split(',')
        console.log(arr1, arr2)
        //        photoList:[], //多张普通图片
        // photoThum:[],//多张缩略图

        // 删除
        for (var i = 0; i < this.photoList.length; i++) {
          for (var j = 0; j < arr1.length; j++) {
            if (this.photoList[i] == arr1[j]) {
              this.photoList[i] = ''
              // this.photoList.push(this.photoList[i])
            }
          }
        }
        //
        for (var i = 0; i < this.photoThum.length; i++) {
          for (var j = 0; j <= arr2.length; j++) {
            if (this.photoThum[i] == arr2[j]) {
              this.photoThum[i] = ''
              // this.photoThum.push(this.photoThum[i])
            }
          }
        }

        for (var i = 0; i < this.photoList.length; i++) {
          if (this.photoList[i] == '') {
            this.photoList.splice(i,1)
            i=i-1
          }
        }
        for (var i = 0; i < this.photoThum.length; i++) {
          if (this.photoThum[i] == '') {
            this.photoThum.splice(i,1)
            i=i-1
          }
        }
        // 删除图片后的路径
         this.addForm.photoUrl = this.photoList.join(',')
        this.addForm.thumbnailUrl = this.photoThum.join(',')
        // console.log(this.photoList, this.photoThum)
        // console.log(this.addForm.photoUrl, this.addForm.thumbnailUrl)
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    // 上传封面图片成功
    handleIconSuccess(res, file) {
      if (res.code == '200') {
        console.log(res)
        this.photoList.push(res.data.savePhotoUrls)
        this.photoThum.push(res.data.saveThumbnailUrls)
        //  console.log( this.photoList,this.photoThum)
        this.addForm.photoUrl = this.photoList.join(',')
        this.addForm.thumbnailUrl = this.photoThum.join(',')
        // console.log(this.addForm.photoUrl, this.addForm.thumbnailUrl)
      } else {
        this.$message.error(res.msg)
      }
    },
    // 点击详情事件
    openDetails(row){
      console.log(row.id)
      // if(this.groupType=='3'){
      //   this.$router.push({ path: '/noticeDetailsBuild/' + row.id+ '/'+this.type  })
      // }else{
        this.$router.push({path:'/owneredit/'+row.id+'/'+this.type})
      // }
    }
  },
}
</script>
<style>
@import '../../../assets/css/common.css';

</style>
<style scoped>
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: #ecf0f5;
  display: flex;
  flex-direction: column;
}
.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 20px 35px 20px -12px;
  height: 40px;
  justify-content: space-between;
}
.el-end {
  height: 47px;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  text-align: center;

}
.build-table {
  height: 100%;
  width: 100%;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  background: #fff;
}
.el-pagination {
  margin: auto;
}
.el-table--fit {
  border-bottom: 1px solid #f5f5f5;
}
.content >>> .el-table th > .cell {
  text-align: center !important;
}
.content >>>   .el-table tr{
  cursor: pointer;
}
</style>